import React from "react";
import DiscountBuy from "@pages/DiscountBuy";
import MerchantDetail from "@pages/MerchantDetail";
import NotFound from "@pages/NotFound";
import { defaultAction } from "@actions/defaultAction";
import { useDispatch, useSelector } from "react-redux";
import { SET_CATEGORY } from "@constants/actionTypes";
import { useParams } from "react-router-dom";
import { initAppBrowser } from "../actions/initApp";
import loadable from "@loadable/component";

const CardCashSpinner = loadable(() =>
  import(
    /* webpackChunkName: "CardCashSpinner" */ "../components/CardCashSpinner"
  )
);

const MerchantDetailOrCategory = ({}) => {
  const params = useParams();
  const dispatch = useDispatch();
  const categories = useSelector(state => state.categories.allCategories);
  const merchantArray = useSelector(state => state.merchantsBuy.sortedByName);
  const selectedCategory = useSelector(
    state => state.userActions.selectedCategory
  );

  if (!merchantArray.length) {
    dispatch(initAppBrowser(["categories", "buy"]));
    return <CardCashSpinner />;
  }

  const filterAndSetCategory = () => {
    let categoryFound = selectedCategory;
    categories.forEach(category => {
      category.categories.forEach(cat => {
        if (cat.url === params.id) {
          if (selectedCategory !== cat.url) {
            categoryFound = cat.url;
            dispatch(defaultAction(SET_CATEGORY, cat.url));
          }
        }
      });
    });
    return categoryFound;
  };

  if (params.id == undefined) {
    return <DiscountBuy />;
  }
  const foundMerchant = merchantArray.find(merch => merch.slug === params.id);

  if (foundMerchant) {
    return <MerchantDetail currentMerchant={foundMerchant} />;
  }

  let categoryFound = filterAndSetCategory();

  if (!categoryFound) {
    if (
      params.id === "discounted-sale-cards" ||
      params.id === "discounted-deals-cards"
    ) {
      let clearanceFound = filterAndSetCategory("discounted-clearance-cards");
      if (clearanceFound) {
        return <DiscountBuy />;
      } else {
        return <NotFound />;
      }
    }
    return <NotFound />;
  }

  return <DiscountBuy />;
};

export default MerchantDetailOrCategory;
